import React from 'react';
import {Box, CircularProgress} from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';
import ListingTableTemplate from '@/components/ListingTableTemplate';

interface ICourse {
    id: string;
    title: string;
    completedActivities: number;
    totalActivities: number;
    completionPercentage: number;
    lastAccess: string;
}

const AllCourses = ({ courses, loading, onReload }) => {
    const columns: GridColDef[] = [
        { 
            field: 'id', 
            headerName: '#', 
            flex: 1,
            renderCell: (params) => courses.findIndex(course => course.id === params.row.id) + 1
        },
        { 
            field: 'title', 
            headerName: 'Course', 
            flex: 1,
            renderCell: (params) => params.value || '-'
        },
        { 
            field: 'completedActivities', 
            headerName: 'Activities completed', 
            flex: 1,
            renderCell: (params) => params.value || 0
        },
        { 
            field: 'totalActivities', 
            headerName: 'Total activities', 
            flex: 1,
            renderCell: (params) => params.value || 0
        },
        { 
            field: 'completionPercentage', 
            headerName: 'Percentage', 
            flex: 1,
            renderCell: (params) => `${params.value || 0}%`
        },
        { 
            field: 'lastAccess', 
            headerName: 'Last access', 
            flex: 1,
            renderCell: (params) => params.value || 'N/A'
        }
    ];

    if (loading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
                <CircularProgress />
            </Box>
        );
    }

    return (
        <ListingTableTemplate
            pageTitle="Course Statistics"
            columns={columns}
            rows={courses}
            loading={loading}
            buttonOptions={[{ label: 'Reload data' }]}
            sortModel={[{ field: 'lastAccess', sort: 'desc' }]}
            getRowId={(row: ICourse) => row.id}
            disableRowSelectionOnClick={true}
            onMenuClick={onReload}
        />
    );
};

export default AllCourses; 